module.exports = __webpack_public_path__ + "assets/img/background-login.805118c2.png";